module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_02-5f44105b416ae45fe27901593b9de78b.png";